module.exports = __webpack_public_path__ + "files/d9993818f660de404f19a168f57048ed.png";